var _defs, _g, _circle, _path, _circle2, _path2, _path3, _path4, _circle3, _path5, _ellipse, _g2, _circle4, _path6, _circle5, _path7, _path8, _path9, _circle6, _circle7, _circle8, _path10, _path11, _path12, _path13, _path14, _ellipse2, _ellipse3, _polygon, _g3, _circle9, _path15, _path16, _circle10, _path17, _path18, _path19, _circle11, _path20, _ellipse4, _ellipse5, _path21, _g4, _circle12, _path22, _circle13, _path23, _path24, _path25, _circle14, _path26, _path27, _path28, _path29, _ellipse6, _ellipse7, _g5, _circle15, _path30, _circle16, _path31, _path32, _path33, _circle17, _path34, _path35, _path36, _ellipse8, _ellipse9, _g6, _circle18, _path37, _path38, _path39, _path40, _circle19, _ellipse10, _ellipse11, _rect, _rect2, _path41, _path42, _line, _path43, _line2, _g7, _circle20, _path44, _path45, _path46, _path47, _path48, _circle21, _ellipse12, _ellipse13, _path49, _path50, _g8, _circle22, _path51, _path52, _path53, _path54, _path55, _circle23, _path56, _path57, _ellipse14, _ellipse15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamIllustration2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "88ce59e9-c4b8-4d1d-9d7a-ce0190159aa8",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 781.43,
    height: 756.44,
    viewBox: "0 0 781.43 756.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3f40125-0363-42ff-a31c-61eb5d655202",
    x1: 116.72,
    y1: 237.98,
    x2: 116.72,
    y2: 6.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "27ca4b3e-9552-41ad-8ba5-de2574048d20",
    x1: 385.08,
    y1: 490.21,
    x2: 385.08,
    y2: 258.44,
    xlinkHref: "#b3f40125-0363-42ff-a31c-61eb5d655202"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "98d2c4cc-353c-49f3-ae94-49dceb95b558",
    x1: 384.97,
    y1: 232.29,
    x2: 384.97,
    y2: 0.51,
    xlinkHref: "#b3f40125-0363-42ff-a31c-61eb5d655202"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1b187342-85ad-4174-acd7-e912b9a9009d",
    x1: 661.23,
    y1: 231.77,
    x2: 661.23,
    y2: 0,
    xlinkHref: "#b3f40125-0363-42ff-a31c-61eb5d655202"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5629c76b-b43c-4c6e-ad7d-c063ce4611c3",
    x1: 115.89,
    y1: 482.62,
    x2: 115.89,
    y2: 250.85,
    xlinkHref: "#b3f40125-0363-42ff-a31c-61eb5d655202"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "94554b54-cbd9-41c5-8f29-6b4786d89c61",
    x1: 665.55,
    y1: 495.47,
    x2: 665.55,
    y2: 263.7,
    xlinkHref: "#b3f40125-0363-42ff-a31c-61eb5d655202"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "897c833c-fa4a-4dad-90f9-1cb0d950ec3f",
    x1: 116.72,
    y1: 743.15,
    x2: 116.72,
    y2: 511.38,
    xlinkHref: "#b3f40125-0363-42ff-a31c-61eb5d655202"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b88de7bb-a3e6-477b-a3c4-5c16e389ed83",
    x1: 392.03,
    y1: 756.44,
    x2: 392.03,
    y2: 524.67,
    xlinkHref: "#b3f40125-0363-42ff-a31c-61eb5d655202"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "team") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.72,
    cy: 122.09,
    r: 115.89,
    fill: "url(#b3f40125-0363-42ff-a31c-61eb5d655202)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.72,
    cy: 121.46,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.32,307a112.91,112.91,0,0,0,62.36-18.66c-4.18-22.84-20.09-24.15-20.09-24.15H280.88s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,326.32,307Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.85,
    cy: 118.96,
    r: 50.29,
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.18,164.57h35.09a0,0,0,0,1,0,0v28.07a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V164.57A0,0,0,0,1,98.18,164.57Z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.53,163.27h28.39a3.35,3.35,0,0,1,3.35,3.35v24.72a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V166.62A3.35,3.35,0,0,1,101.53,163.27Z",
    fill: "#be7c5e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M307.53,249.6a50.5,50.5,0,0,0,35.09.1v-4.31H307.53Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.85,
    cy: 129.88,
    r: 50.29,
    fill: "#be7c5e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.66,180.92c.59-2.17,1.33-4.56,3.28-5.69,1.54-.9,3.45-.76,5.23-.67,13.9.76,27.68-2.41,41.2-5.72,7.73-1.89,16-4.19,21-10.42s-1.52-25.81-9.13-28.12c-5-1.53-10.8,1.32-15.54-.92-2.11-1-3.66-2.87-5.48-4.33-3.73-3-8.52-4.21-13.16-5.35-5.42-1.34-11.28-2.65-16.43-.5-4,1.66-6.92,5.17-10.71,7.25-7.21,4-16,2.14-24.26,2.12-2.79,0-6.12.56-7.23,3.12-.75,1.74-.15,3.72-.07,5.61.24,6-4.71,10.67-8.86,15s-8.07,10.51-5.45,15.89c1,2.05,2.83,3.6,3.87,5.63,1.79,3.52.89,7.77,1.54,11.66a29.34,29.34,0,0,0,3.27,8.4c3.08,6,18.55,38.3,25.66,30.09,3.44-4,4-15.56,5.39-20.76Q291.66,192,294.66,180.92Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.07,
    cy: 128.05,
    rx: 4.68,
    ry: 8.77,
    fill: "#be7c5e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 385.08,
    cy: 374.32,
    r: 115.89,
    fill: "url(#27ca4b3e-9552-41ad-8ba5-de2574048d20)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.3,
    cy: 373.58,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M594.68,559.25A112.91,112.91,0,0,0,657,540.59c-4.18-22.84-20.09-24.15-20.09-24.15H549.23s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,594.68,559.25Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.2,
    cy: 371.19,
    r: 54.76,
    fill: "#f55f44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M366.53,416.8h35.09a0,0,0,0,1,0,0v28.07a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V416.8A0,0,0,0,1,366.53,416.8Z",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M369.88,415.5h28.39a3.35,3.35,0,0,1,3.35,3.35v24.72a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V418.85a3.35,3.35,0,0,1,3.35-3.35Z",
    fill: "#fda57d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M575.88,501.83a50.5,50.5,0,0,0,35.09.1v-4.31H575.88Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.2,
    cy: 382.11,
    r: 50.29,
    fill: "#fda57d"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.13,
    cy: 315.49,
    r: 20.24,
    fill: "#f55f44"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.13,
    cy: 295.56,
    r: 13.29,
    fill: "#f55f44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M584.63,398.37a20.24,20.24,0,0,1-10.55-25.88c-.14.28-.28.57-.41.86a20.24,20.24,0,1,0,36.94,16.57c.13-.29.25-.58.37-.88A20.24,20.24,0,0,1,584.63,398.37Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#f55f44"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M557.67,408.15s21.19,43,81,18l-13.92-21.83-24.67-8.86Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M557.67,407.51s21.19,43,81,18l-13.92-21.83-24.67-8.86Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#f55f44"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M574,391.85a249.85,249.85,0,0,1,39.18,0S584.24,394.54,574,391.85Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M596.45,353.24a13.32,13.32,0,0,0-3,.23h.77a13.28,13.28,0,0,1,2,26.33,13.28,13.28,0,0,0,.24-26.56Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#f55f44"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.9,
    cy: 382.06,
    rx: 4.68,
    ry: 8.77,
    fill: "#fda57d"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.49,
    cy: 382.06,
    rx: 4.68,
    ry: 8.77,
    fill: "#fda57d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "345.22 337 355.03 331.94 357.24 340.05 351.23 344.14 345.22 337",
    fill: "#f55f44"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 384.97,
    cy: 116.4,
    r: 115.89,
    fill: "url(#98d2c4cc-353c-49f3-ae94-49dceb95b558)"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.97,
    cy: 115.77,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M550,188.56s-12.86,63.36-19.88,59.85c0,0,67.7,58.48,127.48,0,0,0-10.53-44.65-25.73-59.85Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M594.57,301.33a112.91,112.91,0,0,0,62.36-18.66c-4.18-22.84-20.09-24.15-20.09-24.15H549.12s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,594.57,301.33Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.09,
    cy: 113.27,
    r: 50.29,
    fill: "#333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M366.42,158.88h35.09a0,0,0,0,1,0,0v28.07A17.54,17.54,0,0,1,384,204.49h0a17.54,17.54,0,0,1-17.54-17.54V158.88A0,0,0,0,1,366.42,158.88Z",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M369.77,157.58h28.39a3.35,3.35,0,0,1,3.35,3.35v24.72A17.54,17.54,0,0,1,384,203.19h0a17.54,17.54,0,0,1-17.54-17.54V160.92A3.35,3.35,0,0,1,369.77,157.58Z",
    fill: "#be7c5e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M575.77,243.91a50.5,50.5,0,0,0,35.09.1v-4.31H575.77Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.09,
    cy: 124.18,
    r: 50.29,
    fill: "#be7c5e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M545.3,176.86h95.9s-8.19-38.72-44.44-36.25S545.3,176.86,545.3,176.86Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.84,
    cy: 122.04,
    rx: 4.68,
    ry: 8.77,
    fill: "#be7c5e"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.08,
    cy: 122.04,
    rx: 4.68,
    ry: 8.77,
    fill: "#be7c5e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M545.3,178.16h95.9s-8.19-38.72-44.44-36.25S545.3,178.16,545.3,178.16Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 661.23,
    cy: 115.89,
    r: 115.89,
    fill: "url(#1b187342-85ad-4174-acd7-e912b9a9009d)"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 661.45,
    cy: 115.14,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M870.83,300.82a112.91,112.91,0,0,0,62.36-18.66C929,259.31,913.1,258,913.1,258H825.39s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,870.83,300.82Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.36,
    cy: 112.75,
    r: 54.76,
    fill: "#72351c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M642.68,158.36h35.09a0,0,0,0,1,0,0v28.07A17.54,17.54,0,0,1,660.23,204h0a17.54,17.54,0,0,1-17.54-17.54V158.36A0,0,0,0,1,642.68,158.36Z",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M646,157.06h28.39a3.35,3.35,0,0,1,3.35,3.35v24.72a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V160.41a3.35,3.35,0,0,1,3.35-3.35Z",
    fill: "#fda57d"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M852,243.39a50.5,50.5,0,0,0,35.09.1v-4.31H852Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.36,
    cy: 123.67,
    r: 50.29,
    fill: "#fda57d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M833.82,149.71s21.19,43,81,18l-13.92-21.83-24.67-8.86Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M833.82,149.08s21.19,43,81,18l-13.92-21.83-24.67-8.86Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#72351c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M833.63,146.17a29.05,29.05,0,0,1,7.2-11.71c9.89-9.78,26.11-11.84,34.43-23a6.51,6.51,0,0,1-3,9.18c8-.05,17.21-.75,21.71-7.31a14.91,14.91,0,0,1-2.51,15.74c7.06.32,14.6,5.11,15.06,12.17.3,4.7-2.64,9.15-6.51,11.85S891.48,157,886.88,158C873.46,161,824.87,173.41,833.63,146.17Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#72351c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M919.93,195.89h-1.33L892.66,219c-25-11.7-43.34,0-43.34,0l-27.2-22.14-2.74.34a50.29,50.29,0,0,0,100.56-1.29Zm-50.36,31.95c-9.78,0-17.71-2-17.71-4.43s7.93-4.43,17.71-4.43,17.71,2,17.71,4.43S879.35,227.84,869.56,227.84Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#72351c"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.05,
    cy: 123.62,
    rx: 4.68,
    ry: 8.77,
    fill: "#fda57d"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.64,
    cy: 123.62,
    rx: 4.68,
    ry: 8.77,
    fill: "#fda57d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.89,
    cy: 366.73,
    r: 115.89,
    fill: "url(#5629c76b-b43c-4c6e-ad7d-c063ce4611c3)"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.11,
    cy: 365.99,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M325.49,551.66A112.91,112.91,0,0,0,387.84,533c-4.18-22.84-20.09-24.15-20.09-24.15H280s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,325.49,551.66Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.01,
    cy: 363.6,
    r: 54.76,
    fill: "#333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.34,409.21h35.09a0,0,0,0,1,0,0v28.07a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V409.21A0,0,0,0,1,97.34,409.21Z",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M100.69,407.91h28.39a3.35,3.35,0,0,1,3.35,3.35V436a17.54,17.54,0,0,1-17.54,17.54h0A17.54,17.54,0,0,1,97.34,436V411.25a3.35,3.35,0,0,1,3.35-3.35Z",
    fill: "#fdb797"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M306.69,494.24a50.5,50.5,0,0,0,35.09.1V490H306.69Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.01,
    cy: 374.52,
    r: 50.29,
    fill: "#fdb797"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M288.48,400.55s21.19,43,81,18l-13.92-21.83-24.67-8.86Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M288.48,399.92s21.19,43,81,18l-13.92-21.83-24.67-8.86Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M288.29,397a29.05,29.05,0,0,1,7.2-11.71c9.89-9.78,26.11-11.84,34.43-23a6.51,6.51,0,0,1-3,9.18c8-.05,17.21-.75,21.71-7.31a14.91,14.91,0,0,1-2.51,15.74c7.06.32,14.6,5.11,15.06,12.17.3,4.7-2.64,9.15-6.51,11.85s-8.54,3.93-13.14,4.95C328.11,411.85,279.53,424.26,288.29,397Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.7,
    cy: 374.47,
    rx: 4.68,
    ry: 8.77,
    fill: "#fdb797"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.29,
    cy: 374.47,
    rx: 4.68,
    ry: 8.77,
    fill: "#fdb797"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 665.55,
    cy: 379.58,
    r: 115.89,
    fill: "url(#94554b54-cbd9-41c5-8f29-6b4786d89c61)"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.55,
    cy: 378.95,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M875.15,564.51a112.91,112.91,0,0,0,62.36-18.66c-4.18-22.84-20.09-24.15-20.09-24.15H829.7s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,875.15,564.51Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M647,422.06h35.09a0,0,0,0,1,0,0v28.07a17.54,17.54,0,0,1-17.54,17.54h0A17.54,17.54,0,0,1,647,450.13V422.06A0,0,0,0,1,647,422.06Z",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M650.35,420.76h28.39a3.35,3.35,0,0,1,3.35,3.35v24.72a17.54,17.54,0,0,1-17.54,17.54h0A17.54,17.54,0,0,1,647,448.83V424.11a3.35,3.35,0,0,1,3.35-3.35Z",
    fill: "#fdb797"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M856.35,507.09a50.5,50.5,0,0,0,35.09.1v-4.31H856.35Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.67,
    cy: 387.37,
    r: 50.29,
    fill: "#fdb797"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 615.42,
    cy: 385.22,
    rx: 4.68,
    ry: 8.77,
    fill: "#fdb797"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 713.66,
    cy: 385.22,
    rx: 4.68,
    ry: 8.77,
    fill: "#fdb797"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 634.03,
    y: 387.61,
    width: 21.51,
    height: 10.76,
    rx: 4.35,
    ry: 4.35,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 883.1,
    y: 459.39,
    width: 21.51,
    height: 10.76,
    rx: 4.35,
    ry: 4.35,
    transform: "translate(1578.42 857.75) rotate(180)",
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M864,460.43s6.82-3.7,19.5,0",
    transform: "translate(-209.28 -71.78)",
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M908.72,422.7l12.34,28.67S936.15,432.35,908.72,422.7Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#858585"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 695.32,
    y1: 392.99,
    x2: 713.74,
    y2: 376.54,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M839.2,422.7l-12.34,28.67S811.77,432.35,839.2,422.7Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#858585"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 634.03,
    y1: 392.99,
    x2: 615.36,
    y2: 376.54,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.72,
    cy: 627.26,
    r: 115.89,
    fill: "url(#897c833c-fa4a-4dad-90f9-1cb0d950ec3f)"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.72,
    cy: 626.63,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M388.75,708.61c0,41.78-27.26,88.29-60.89,88.29S267,750.39,267,708.61s27.26-63,60.89-63S388.75,666.84,388.75,708.61Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#fdd835"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M326.32,812.2a112.91,112.91,0,0,0,62.36-18.66c-4.18-22.84-20.09-24.15-20.09-24.15H280.88s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,326.32,812.2Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M98.18,669.74h35.09a0,0,0,0,1,0,0v28.07a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V669.74A0,0,0,0,1,98.18,669.74Z",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.53,668.44h28.39a3.35,3.35,0,0,1,3.35,3.35v24.72a17.54,17.54,0,0,1-17.54,17.54h0a17.54,17.54,0,0,1-17.54-17.54V671.79A3.35,3.35,0,0,1,101.53,668.44Z",
    fill: "#fdb797"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M307.53,754.77a50.5,50.5,0,0,0,35.09.1v-4.31H307.53Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.85,
    cy: 635.05,
    r: 50.29,
    fill: "#fdb797"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.6,
    cy: 632.9,
    rx: 4.68,
    ry: 8.77,
    fill: "#fdb797"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.84,
    cy: 632.9,
    rx: 4.68,
    ry: 8.77,
    fill: "#fdb797"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M280.57,679.55S309,718.46,374.2,705.17c0,0,7.28-8.86-10.44-36.06S296.7,646.34,280.57,679.55Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M280.57,678.92S309,717.83,374.2,704.54c0,0,7.28-8.86-10.44-36.06S296.7,645.71,280.57,678.92Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#fdd835"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 392.03,
    cy: 640.55,
    r: 115.89,
    fill: "url(#b88de7bb-a3e6-477b-a3c4-5c16e389ed83)"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.26,
    cy: 639.81,
    r: 113.44,
    fill: "#f5f5f5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M663.95,722.77c0,37.74-27.11,56.31-62.32,56.31s-65.16-18.57-65.16-56.31,28.54-68.33,63.74-68.33S663.95,685,663.95,722.77Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M601.63,825.48A112.91,112.91,0,0,0,664,806.82c-4.18-22.84-20.09-24.15-20.09-24.15H556.19s-15,1.23-19.7,22.25A112.92,112.92,0,0,0,601.63,825.48Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#4285F4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M373.49,683h35.09a0,0,0,0,1,0,0v28.07A17.54,17.54,0,0,1,391,728.64h0a17.54,17.54,0,0,1-17.54-17.54V683A0,0,0,0,1,373.49,683Z",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M376.83,681.73h28.39a3.35,3.35,0,0,1,3.35,3.35V709.8A17.54,17.54,0,0,1,391,727.34h0a17.54,17.54,0,0,1-17.54-17.54V685.07a3.35,3.35,0,0,1,3.35-3.35Z",
    fill: "#fda57d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M582.84,768.06a50.5,50.5,0,0,0,35.09.1v-4.31H582.84Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.16,
    cy: 648.33,
    r: 50.29,
    fill: "#fda57d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M542.48,723.4s31.32-3.8,55-34.16c0,0,31.32,34.48,53.14,30.68,0,0,12.65-13.29,0-26.57s-22.46-30.05-39.22-27.84-37.33,3.16-46.18,11.07S542.48,723.4,542.48,723.4Z",
    transform: "translate(-209.28 -71.78)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M542.48,722.77s31.32-3.8,55-34.16c0,0,31.32,34.48,53.14,30.68,0,0,12.65-13.29,0-26.57s-22.46-30.05-39.22-27.84S574.11,668,565.26,676,542.48,722.77,542.48,722.77Z",
    transform: "translate(-209.28 -71.78)",
    fill: "#333"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 340.85,
    cy: 648.29,
    rx: 4.68,
    ry: 8.77,
    fill: "#fda57d"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.44,
    cy: 648.29,
    rx: 4.68,
    ry: 8.77,
    fill: "#fda57d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIllustration2);
export default __webpack_public_path__ + "static/media/team-illustration-2.4565f22c351462c98ad6a9d764e517ea.svg";
export { ForwardRef as ReactComponent };